const paddingMultiplier = 0.035;
const defaultWidth = '80%';

function ResizingIFrame(props)
{
    const resize = () => {
        var elementIframe = document.getElementById(props.id);
        if(elementIframe)
        {
            var currentScrollHeight = elementIframe.contentDocument.documentElement.scrollHeight;
            var padding = Math.floor(currentScrollHeight * paddingMultiplier);
            var newHeight = currentScrollHeight + padding;
            document.getElementById(props.id).style.height = newHeight + "px";
        }
    }

    const htmlPath = process.env.PUBLIC_URL + props.htmlName;

    return (
        <iframe id={props.id} onLoad={resize} title={props.iFrameTitle} src={htmlPath} style={{ width: defaultWidth, height: 'auto', border: 'none'}} />
    );
}

export default ResizingIFrame;